import React from 'react';

import CompanyHistoryWrap from './styled/CompanyHistoryWrap';
import Entries from './Entries';

const DATA = [
  { year: 2013, months: ['march', 'december'] },
  { year: 2014, months: ['august', 'december'] },
  { year: 2015, months: ['april', 'december'] },
  { year: 2016, months: ['january', 'june', 'december'] },
  { year: 2017, months: ['july', 'october', 'december'] },
  { year: 2018, months: ['april', 'may', 'september'] },
  { year: 2019, months: ['march', 'november'] },
  { year: 2020 },
  { year: 2021, months: ['march'] },
];

const CompanyHistory: React.FC = () => (
  <CompanyHistoryWrap>
    {DATA.map((data, i) => (
      <Entries
        {...data}
        year={data.year.toString()}
        key={data.year.toString()}
        last={i === DATA.length - 1}
      />
    ))}
  </CompanyHistoryWrap>
);

export default CompanyHistory;
